// extracted by mini-css-extract-plugin
export default {"sidebar":"GraphicProperties_sidebar__b0dyU","headerBlock":"GraphicProperties_headerBlock__Z8kQb"};